<template>
    <div
        :class="['replyChatMessageContainer', `${getContainerWidth()}`, { merchantMessage: message.sent_by_merchant, loading: oldMessageLoading }]">
        <div v-if="!oldMessageLoading"
            :class="['oldMessageContainer', { merchantMessage: oldMessage.sent_by_merchant, noMessage: !oldMessage.type, withImage: oldMessage.type == MessageTypes.Image }]">
            <div>
                <div :class="['sender', 'text-truncate', { merchantMessage: oldMessage.sent_by_merchant }]">
                    {{ oldMessage.sent_by_merchant ? $t('You') : oldMessage.profile_name ?? '' }}
                </div>
                <div class="textMessage text-truncate" v-if="!oldMessage.type">
                    {{ $t('Old Message Not Available') }}
                </div>
                <div class="textMessage text-truncate"
                    v-else-if="oldMessage.type == MessageTypes.Text && !oldMessage.linker_payment_status">
                    {{ oldMessage.content }}
                </div>
                <div class="paymentMessage text-truncate"
                    v-else-if="oldMessage.type == MessageTypes.Text && !!oldMessage.linker_payment_status">
                    {{ $t(oldMessage.linker_payment_status == PaymentStatuses.success
            ? 'Payment Succeeded' : 'Payment Failed')
                    }}
                </div>
                <div class="orderText text-truncate" v-else-if="oldMessage.type == MessageTypes.Order">
                    <img height="16" width="16" :src="loadFile(images.cart)">
                    {{ $t('OrderReplyMessage') }} {{ oldMessage.linker_order_id }}
                </div>
                <div class="imageText text-truncate" v-else-if="oldMessage.type == MessageTypes.Image">
                    <img height="16" width="16" :src="loadFile(images.camera)">
                    {{ $t('Image') }}
                </div>
                <div class="imageText text-truncate" v-else-if="oldMessage.type == MessageTypes.Video">
                    <i class="bi bi-camera-video me-2"></i>
                    {{ $t('Video') }}
                </div>
                <div class="audioText text-truncate" v-else-if="oldMessage.type == MessageTypes.Audio">
                    <img height="16" width="16" :src="loadFile(images.microphone)">
                    {{ oldMessage?.content?.audio?.duration }}
                </div>
                <div class="imageText text-truncate" v-else-if="oldMessage.type == MessageTypes.Document">
                    <i class="bi bi-file-earmark-text me-2"></i>
                    {{ $t("file") }}
                </div>
                <div class="imageText text-truncate" v-else-if="oldMessage.type == MessageTypes.Location">
                    <i class="bi bi-geo-alt me-2"></i>
                    {{ $t("location") }}
                </div>
                <div class="paymentMessage text-truncate" v-else-if="oldMessage?.type == MessageTypes.Interactive">
                    {{ getInteractiveMessageProps(oldMessage)?.text ?? $t('Not Supported Message Title') }}
                </div>
                <div class="paymentMessage text-truncate" v-else-if="oldMessage?.type == MessageTypes.ReplyToItem">
                    <div>{{ $t('product') }} #{{ referredProductId }}</div>
                    <button class="btn btn-sm ripple show-item-btn" data-bs-toggle="modal"
                        data-bs-target="#kt_modal_item_details">
                        {{ $t('Show Product Details') }}
                    </button>
                </div>
            </div>
            <div class="messageImage" v-if="oldMessage.type == MessageTypes.Image">
                <img :src="oldMessage.content.image.url" height="40" width="40">
            </div>
            <div class="text-truncate" v-if="oldMessage.type == MessageTypes.Document">
                {{ oldMessage.content.document.filename }}
            </div>
            <div class="text-truncate text-campaign" v-if="oldMessage.type == MessageTypes.Template">
                <i class="icon bi bi-megaphone-fill"></i> <span>{{ oldMessage?.extra_data?.campaign?.name }}</span>
            </div>
        </div>
        <div v-else class="skeleton mb-2"></div>
        <div class="messageContent">
            <div class="textContent" v-if="message.type == MessageTypes.Text || (message.type == MessageTypes.Template && message?.extra_data?.template?.is_system && !message.linker_payment_status)">
                {{ message.type == MessageTypes.Text ? message.content : message?.extra_data?.template?.components?.[1]?.text }}
            </div>
            <div class="textContent" v-if="message.type == MessageTypes.Button">
                {{ message.content?.text }}
            </div>
            <Audio v-if="message.type == MessageTypes.Audio" :message="message"></Audio>
            <ImagesComponent v-else-if="message.type == MessageTypes.Image" :message="message" />
            <OrderType v-else-if="message?.type == 'order'"
                :url="`${locale}/linked_marketplace/${message.linker_linked_marketplace_id}/orders/show/${message.linker_order_id}`"
                :message="message" :data_id_ref="index" />
            <Document v-else-if="message.type == MessageTypes.Document" :message="message" />
            <Location v-else-if="message.type == MessageTypes.Location" :message="message" />
            <template v-else-if="message.type == MessageTypes.Interactive">
                <PaymentDetails v-if="message?.content?.interactive?.type == InteractiveSubtypes.PaymentSummary"
                    :message="message" />
                <InteractiveButtons v-if="message?.content?.interactive?.type == InteractiveSubtypes.InteractiveButtons"
                    :message="message" />
                <div class="audioText text-truncate textContent"
                    v-else-if="message?.content?.type == InteractiveSubtypes.ButtonReply">
                    {{ message.content?.button_reply?.title }}
                </div>
                <div class="audioText text-truncate textContent"
                    v-else-if="message?.content?.type == InteractiveSubtypes.nfmReply">
                    {{ message.content?.nfm_reply?.body }}
                </div>
            </template>
        </div>
        <ItemModal v-if="oldMessage?.type == MessageTypes.ReplyToItem" :referredProductId="referredProductId" />
    </div>
</template>

<script setup>
import { ref, onMounted, defineAsyncComponent } from 'vue'
import { MessageTypes, PaymentStatuses, InteractiveSubtypes } from '@/components/whatsapp-managment/interfaces.js'
import { loadFile, formatTimeDuration, fetchAudioMetadata, getInteractiveMessageProps } from '@/components/utils.js'
import Audio from '@/components/whatsapp-managment/includes/ReplyMessages/ReceivedReply/Audio.vue'
import OrderType from "@/components/whatsapp-managment/includes/types/order.vue";
import Document from "@/components/whatsapp-managment/includes/types/Document.vue";
import Location from "@/components/whatsapp-managment/includes/types/Location.vue";
import InteractiveButtons from "@/components/whatsapp-managment/includes/types/InteractiveButtons.vue";
import ImagesComponent from '@/components/whatsapp-managment/includes/ReplyMessages/ReceivedReply/Images.vue'
import PaymentDetails from '@/components/whatsapp-managment/includes/ReplyMessages/ReceivedReply/PaymentDetails.vue'
import { db } from '@/firebase'
import { collection, query, where, getDocs } from "firebase/firestore"

const props = defineProps({
    message: {
        type: Object,
        default: () => ({}),
        required: true,
    },
    conversation: {
        type: Object,
        default: () => ({}),
        required: true,
    },
});

const ItemModal = defineAsyncComponent(() => import('./ItemModal.vue'));

const tenant = props.conversation.tenantId;
const oldMessage = ref({})
const referredProductId = ref('')
const oldMessageLoading = ref(false)

const images = {
    camera: 'camera.svg',
    cart: 'cart.svg',
    microphone: 'microphone.svg',
}

const getContainerWidth = () => {
    if (props.message.type == MessageTypes.Image) {
        // const { messageImages } = props.message.content.image.url ?? {}
        // if (messageImages && messageImages.length == 1) return 'singleImage'
        // if ((messageImages && messageImages.length > 1)) return 'multipleImages'
        return 'singleImage'
    }
    return 'noImage'
}

const getOldMessage = async () => {
    referredProductId.value = props?.message?.reply_message?.referred_product?.product_retailer_id ?? ''
    if (referredProductId.value) {
        oldMessage.value = {
            sent_by_merchant: false,
            type: MessageTypes.ReplyToItem,
            profile_name: props?.conversation?.profile_name
        }
        return
    }
    try {
        oldMessageLoading.value = true
        const messagesRef = collection(db, `tenants/${tenant}/conversations/${props.conversation.id}/messages`);
        const q = query(
            messagesRef,
            where('message_id', '==', `${props.message.reply_message.id}`),
        );
        const querySnapshot = await getDocs(q);
        const messages = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        oldMessage.value = messages.length ? messages[0] : {}
        if (oldMessage.value.type == MessageTypes.Audio) {
            const audioUrl = oldMessage?.value?.content?.audio?.url
            const duration = await fetchAudioMetadata(audioUrl)
            oldMessage.value.content.audio.duration = formatTimeDuration(duration ?? 0)
        }
    } catch (error) {
        console.error("Error fetching old messages: ", error);
    } finally {
        oldMessageLoading.value = false
    }
}

onMounted(async () => {
    await getOldMessage()
})
</script>

<style scoped lang="scss">
@import "./styles/index.scss";
.text-campaign{
    color: #475467;
    .icon:before{
        color: #475467;
    }
}
</style>
